import { render } from "./CostLimitView.vue?vue&type=template&id=4e4ff580&scoped=true"
import script from "./CostLimitView.vue?vue&type=script&lang=js"
export * from "./CostLimitView.vue?vue&type=script&lang=js"

import "./CostLimitView.vue?vue&type=style&index=0&id=4e4ff580&scoped=true&lang=css"

import exportComponent from "/builds/swisscom/messaging/web-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4ff580"]])

export default __exports__